const MP_API_URL = 'https://reportesmp.netizar.com/api';
// const MP_API_URL = 'http://localhost:3002/api';
export const conciliarPagos = async (data) => {
  // let urlMP = data.empresa === 1 ?MP_API_URL_HIPER:MP_API_URL_NATURAL
  
  try {
    // const response = await fetch(`${urlMP}/reportes/conciliacion`, {
    const response = await fetch(`${MP_API_URL}/reportes/conciliacion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error en la conciliación');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error en conciliarPagos:', error);
    throw error;
  }
};

export const getPaymentsByStore = async (storeId, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/payments/store/${storeId}/${desde}/${hasta}`
    );
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentsByStore:', error);
    throw error;
  }
};

export const getPaymentSummary = async (storeId, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/summary/${storeId}/${desde}/${hasta}`
    );
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentSummary:', error);
    throw error;
  }
};

export const getPaymentStats = async (storeId, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/stats/${storeId}/${desde}/${hasta}`
    );
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentStats:', error);
    throw error;
  }
};

export const getPaymentById = async (paymentId) => {
  try {
    const response = await fetch(`${MP_API_URL}/reportes/payment/${paymentId}`);
    return await response.json();
  } catch (error) {
    console.error('Error en getPaymentById:', error);
    throw error;
  }
};

export const getNoAprobados = async (empresa, desde, hasta) => {
  try {
    const response = await fetch(
      `${MP_API_URL}/reportes/no-aprobados/${desde}/${hasta}?empresa=${empresa}`
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al obtener pagos no aprobados');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getNoAprobados:', error);
    throw error;
  }
};